import { Injectable } from '@angular/core';
import { AgGridWithoutCacheStore } from 'app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.store';
import { WorkflowTaskService } from './workflow-task.service';
import { UtilCommon } from 'app/shared/common/utils/UtilCommon';
import { UtilComponent } from 'app/shared/common/utils/UtilComponent';
import { TranslocoService } from '@ngneat/transloco';
import { STATUS_IN_DATABASE } from 'app/shared/common/constants/Status.constant';
import { FLOW_TYPE, REQUEST_CANDIDATE_STATUS, REQUISITION_CANDIDATE_OFFER_STATUS } from './workflow-task.constant';
import { getAllCandidateIds } from './workflow-task.util';

@Injectable()
export class WorkflowTaskStore extends AgGridWithoutCacheStore {

    constructor(protected _service: WorkflowTaskService,
        private _utilComponent: UtilComponent,
        private _translocoService: TranslocoService
    ) {
        super(_service);
    }

    async isValidScanCandidate(candidateId): Promise<boolean> {
        const where = { id: { _eq: candidateId } };
        const result = await this._service.getCandidateIdentityForAcceptOffer(where);
        if (UtilCommon.isNotNull(result) && UtilCommon.isArray(result?.data, true)) {
            const candidateIdentity = result?.data[0];
            const worker = candidateIdentity?.worker;
            if (worker) {
                const address = worker?.address;
                if (!UtilCommon.isArray(address, true)) {
                    return false;
                }
                const legaldoc = worker?.legaldoc;
                if (!UtilCommon.isArray(legaldoc, true)) {
                    return false;
                }
                const attachment = worker?.attachment;
                if (!UtilCommon.isArray(attachment, true)) {
                    return false;
                }
                // if (!worker?.pobId || !worker?.ethnicityId) {
                //     return false;
                // }
            }
        }
        return true;
    }

    async isValidTransferCnB(requisitionId: any, requestCandidate: any, messageValid: string = 'CANDIDATE.MESSAGE.CANDIDATE_SUGGEST_INVALID_TRANSFER'): Promise<boolean> {
        let isValid = true;
        const resultCheckQuantity = await this._service.queryCheckCandidateDoneInRequisition(requisitionId);
        if (UtilCommon.isNotNull(resultCheckQuantity)) {
            let totalJobQuantity = 0;
            let countDone = 0;
            let countOther = 0;
            let countClose = 0; // Close Fail Cancel Cancel_Onboarding
            const requisition = UtilCommon.isArray(resultCheckQuantity?.requisition, true) ? resultCheckQuantity?.requisition[0] : null;
            if (requisition) {
                const jobs = requisition?.jobs;
                if (UtilCommon.isArray(jobs, true)) {
                    for (let obj of jobs) {
                        totalJobQuantity += obj.jobQuantity ? obj.jobQuantity : 0;
                    }
                }
            }
            const requisitionCandidate = resultCheckQuantity?.requisitionCandidate;
            let candidatesName = '';
            if (UtilCommon.isArray(requisitionCandidate, true)) {
                candidatesName = '<ul>';
                for (let obj of requisitionCandidate) {
                    const status = obj.status;
                    const offerStatus = obj?.offerStatus;
                    const flowType = obj?.flowType;
                    if (REQUEST_CANDIDATE_STATUS.DONE === status
                        || (REQUEST_CANDIDATE_STATUS.OFFER === status &&
                            (offerStatus
                                && REQUISITION_CANDIDATE_OFFER_STATUS.WAITING_SCAN_CANDIDATE !== offerStatus
                                && REQUISITION_CANDIDATE_OFFER_STATUS.WAITING_TRANSFERS_CNB !== offerStatus))
                        || (REQUEST_CANDIDATE_STATUS.WAITING_CANDIDATE_ACCEPTANCE === status && FLOW_TYPE.FLOW_3 === flowType)
                    ) {
                        countDone++;
                    } else if (REQUEST_CANDIDATE_STATUS.CLOSE === status
                        || REQUEST_CANDIDATE_STATUS.FAIL === status
                        || REQUEST_CANDIDATE_STATUS.CANCEL === status
                        || REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING === status
                    ) {
                        countClose++;
                    } else {
                        countOther++;
                        const fullName = obj?.candidate?.lastName + " " + obj?.candidate?.firstName;
                        const fullname = obj?.candidate?.fullname;
                        if (!(fullName == UtilCommon.getLabelLanguage(requestCandidate['fullName'])
                            || fullname == UtilCommon.getLabelLanguage(requestCandidate['fullName']))) {
                            candidatesName += '<li>' + obj?.candidate?.fullname + '</li>';
                        }
                    }
                }
                candidatesName += '</ul>';
            }
            // Full Candidate
            if (totalJobQuantity === countDone) {
                let message = this._translocoService.translate('CANDIDATE.MESSAGE.CANDIDATE_MATCHED_QUANTITY', { n: totalJobQuantity });
                this._utilComponent.showTranslateSnackbar(message, 'error');
                isValid = false;
                // Last Candidate
            } else if ((totalJobQuantity - countDone) === 1 && countOther > 1) {
                let message = this._translocoService.translate('CANDIDATE.MESSAGE.CANDIDATE_MATCHED_QUANTITY_FINAL', { n: totalJobQuantity, y: candidatesName });
                this._utilComponent.showTranslateSnackbar(message, 'error');
                isValid = false;
            }
        }

        // HRM-1673
        const workerId = requestCandidate['workerId'];
        const personalEmail = requestCandidate['personalEmail'];
        if (workerId) {
            const resultCandidateGroup = await this._service.queryCandidateGroupForValidTransfer([workerId]);
            if (UtilCommon.isNotNull(resultCandidateGroup) && UtilCommon.isArray(resultCandidateGroup?.worker, true)) {
                const worker = resultCandidateGroup?.worker[0];
                const ids = getAllCandidateIds(worker, personalEmail);
                if (UtilCommon.isArray(ids, true)) {
                    const where = {
                        candidateId: { _in: ids },
                        status: {
                            _nin: [REQUEST_CANDIDATE_STATUS.OFFER,
                            REQUEST_CANDIDATE_STATUS.DONE,
                            REQUEST_CANDIDATE_STATUS.CLOSE,
                            REQUEST_CANDIDATE_STATUS.FAIL,
                            REQUEST_CANDIDATE_STATUS.CANCEL,
                            REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING]
                        }
                    }
                    const resultRequisitionCandidate = await this._service.getAllRequisitionCandidateWhere(where)
                    if (UtilCommon.isNotNull(resultRequisitionCandidate) && UtilCommon.isArray(resultRequisitionCandidate?.data, true)) {
                        let candidatesName = '<ul>';
                        let hasOtherRequest = false;
                        for (let obj of resultRequisitionCandidate?.data) {
                            if (obj?.requisitionId == requisitionId
                                && obj?.candidateId == requestCandidate['id']
                            ) {
                                continue;
                            }
                            const candidateName = UtilCommon.getLabelLanguage(obj?.candidate?.worker?.fullName);
                            const requisitionCode = obj?.requisition?.code;
                            candidatesName += '<li>' + (candidateName + ' ' + requisitionCode) + '</li>';
                            hasOtherRequest = true;
                        }
                        candidatesName += '</ul>';
                        if (hasOtherRequest) {
                            let message = this._translocoService.translate(messageValid, { n: candidatesName });
                            this._utilComponent.showTranslateSnackbar(message, 'error');
                            isValid = false;
                        }
                    }
                }
            }
        }
        return isValid;
    }

    async isValidCandidateProcessInOtherRequisition(requisitionId: any, requisitionCandidate): Promise<boolean> {
        let isValid = true;
        const where = {
            recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE },
            candidateId: { _eq: requisitionCandidate['id'] },
            requisitionId: { _neq: requisitionId },
            status: {
                _nin: [REQUEST_CANDIDATE_STATUS.DONE,
                REQUEST_CANDIDATE_STATUS.CLOSE,
                REQUEST_CANDIDATE_STATUS.FAIL,
                REQUEST_CANDIDATE_STATUS.CANCEL,
                REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING]
            }
        }
        const resultCheckQuantity = await this._service.queryCheckCandidateRequisition(where);
        if (UtilCommon.isNotNull(resultCheckQuantity)) {
            const checkCandidateRequisition = resultCheckQuantity?.checkCandidateRequisition;
            if (UtilCommon.isArray(checkCandidateRequisition, true)) {
                let otherRequest = '<ul>';
                for (let obj of checkCandidateRequisition) {
                    const otherRequisition = obj?.requisition?.code;
                    if (otherRequisition) {
                        otherRequest += '<li>' + otherRequisition + '</li>';
                    }
                }
                otherRequest += '</ul>';
                let message = this._translocoService.translate('CANDIDATE.MESSAGE.CANDIDATE_MATCHED_QUANTITY_OTHER', { n: UtilCommon.getLabelLanguage(requisitionCandidate['fullName']), y: otherRequest });
                this._utilComponent.showTranslateSnackbarMessage(message, 'error');
                isValid = false;
            }
        }
        return isValid;
    }

    async isValidCandidateOfferInOtherRequisition(requisitionId: any, requisitionCandidate): Promise<boolean> {
        let isValid = true;
        const where = {
            recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE },
            candidateId: { _eq: requisitionCandidate['id'] },
            requisitionId: { _neq: requisitionId },
            status: { _in: [REQUEST_CANDIDATE_STATUS.WAITING_OFFER, REQUEST_CANDIDATE_STATUS.WAITING_CANDIDATE_ACCEPTANCE, REQUEST_CANDIDATE_STATUS.OFFER] }
        }
        const resultCheckQuantity = await this._service.queryCheckCandidateRequisition(where);
        if (UtilCommon.isNotNull(resultCheckQuantity)) {
            const checkCandidateRequisition = resultCheckQuantity?.checkCandidateRequisition;
            if (UtilCommon.isArray(checkCandidateRequisition, true)) {
                let otherRequest = '<ul>';
                for (let obj of checkCandidateRequisition) {
                    const otherRequisition = obj?.requisition?.code;
                    if (otherRequisition) {
                        otherRequest += '<li>' + otherRequisition + '</li>';
                    }
                }
                otherRequest += '</ul>';
                let message = this._translocoService.translate('CANDIDATE.MESSAGE.CANDIDATE_HAS_OFFER', { n: UtilCommon.getLabelLanguage(requisitionCandidate['fullName']), y: otherRequest });
                this._utilComponent.showTranslateSnackbarMessage(message, 'error');
                isValid = false;
            }
        }
        return isValid;
    }

    async getCandidateContactEmail(candidateId: any): Promise<any> {
        const where = { id: { _eq: candidateId } };
        const result = await this._service.getCandidateContactEmail(where);
        if (UtilCommon.isNotNull(result) && UtilCommon.isArray(result?.data, true)) {
            const data = result?.data[0];
            return data?.contact_email || data?.personal_email;
        }
        return null;
    }

    async updateStatusAssignment(id: any, recordStatus: string = STATUS_IN_DATABASE.ACTIVE): Promise<void> {
        // const where = { id: { _eq: id } };
        const _set = { recordStatus: recordStatus };
        const result = await this._service.updateAssignment(id, _set);
        return result;
    }

    async deleteAssignmentAttachment(ids: any): Promise<void> {
        // const where = { id: { _in: ids } };
        const result = await this._service.deleteAssignmentAttachment(ids);
        return result;
    }

    async deleteAssignment(id: any): Promise<void> {
        // const where = { id: { _eq: id } };
        const result = await this._service.deleteAssignment(id);
        return result;
    }
}